export const EMOTION_LABELS = {
  neutral: '平静',
  happy: '开心',
  laughing: '大笑',
  loving: '喜欢',
  embarrassed: '害羞',
  cool: '酷',
  winking: '眨眼',
  thinking: '思考',
  confused: '困惑',
  surprised: '惊讶',
  angry: '生气',
  sad: '难过',
  sleepy: '困',
  relaxed: '放松',
  silly: '调皮',
  confident: '自信',
  delicious: '好吃',
}

export const EMOTION_LABELS_EN = {
  neutral: 'Calm',
  happy: 'Happy',
  laughing: 'Laughing',
  loving: 'Loving',
  embarrassed: 'Embarrassed',
  cool: 'Cool',
  winking: 'Wink',
  thinking: 'Thinking',
  confused: 'Confused',
  surprised: 'Surprised',
  angry: 'Angry',
  sad: 'Sad',
  sleepy: 'Sleepy',
  relaxed: 'Relaxed',
  silly: 'Silly',
  confident: 'Confident',
  delicious: 'Yummy',
}

export function normalizeEmotion(emotion) {
  if (!emotion) return 'neutral'
  const e = String(emotion).trim().toLowerCase()
  if (!e) return 'neutral'
  if (e === 'funny') return 'laughing'
  if (e === 'crying') return 'sad'
  if (e === 'shocked') return 'surprised'
  if (e === 'kissy') return 'loving'
  if (e === 'kid' || e === 'eye') return 'neutral'
  return e
}

export function emotionLabelEntry(emotion) {
  const key = normalizeEmotion(emotion)
  const zh = EMOTION_LABELS[key] || key
  const en = EMOTION_LABELS_EN[key] || zh || key
  return { zh, en }
}

export function emotionLabel(emotion, lang = 'zh') {
  const key = normalizeEmotion(emotion)
  if (lang === 'en') return EMOTION_LABELS_EN[key] || EMOTION_LABELS[key] || key
  return EMOTION_LABELS[key] || key
}
